import React, { useEffect, useState } from 'react'

import { Link, useNavigate } from "react-router-dom"
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  CreditCard,
  DeleteIcon,
  EllipsisVertical,
  File,
  Home,
  LineChart,
  ListFilter,
  MoreVertical,
  Package,
  Package2,
  PanelLeft,
  Search,
  Settings,
  ShoppingCart,
  Truck,
  Users2,
} from "lucide-react"

import { Badge } from "../../component/ui/badge"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb"
import { Button } from "../../component/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Input } from "../../component/ui/input"
import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from "../../component/ui/Pagination"
import { Progress } from "../../component/ui/progress"
import { Separator } from "../../component/ui/separator"
import { Sheet, SheetContent, SheetTrigger } from "../../component/ui/sheet"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table"
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../component/ui/tooltip"
import { Switch } from '../ui/switch'
import { getAllSchemeDetails } from '../../utils/util'
import moment from 'moment'
import DialogBox from '../ui/deleteConfirmationDialog'


const DataTable2 = ({ totalPage, currentPage, setCurrentPage, switch: handleUpdateTickerStatus, buttonOptions, data, onRowClick = () => { }, columns, user_type, tableFor = "" }) => {
  const [isOpenDeleteUserConfirmation, setIsOpenDeleteUserConfirmation] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null);
  const handleDeleteConfirmation = (item) => {
    setSelectedItem(item); // Set the selected item
    setIsOpenDeleteUserConfirmation(true); // Open the dialog
  };

  const handleCloseDeleteUserConfirmation = () => {
    console.log("set is open ", isOpenDeleteUserConfirmation)
    setSelectedItem(null)
    setIsOpenDeleteUserConfirmation(false)

  }


  const handleDeleteConfirm = async () => {
    if (!selectedItem) return;

    if (tableFor === "Ticker") {
      buttonOptions[0].actionHandleDeleteTickerForScheme(selectedItem)
    }
    if (tableFor === "Email-Template") {
      buttonOptions[0].actionHandleDeleteEmailTemplate(selectedItem)
    }

    setTimeout(() => {
      setIsOpenDeleteUserConfirmation(false)
    }, 1000);

  };

  const [getAllTickerDetails, setAllTickerDetails] = useState()

  const navigate = useNavigate()

  const handlePageChange = (page) => {
    const setPageIndex = page - 1
    setCurrentPage(setPageIndex); // Update pageIndex based on selected page
  };

  const HandleGetAllTickerDetails = async () => {
    try {
      const response = await getAllSchemeDetails()
      console.log("response for get ticker details", response)
    } catch (error) {
      console.log("Error in Ticker Functions", error)
    }
  }
  useEffect(() => {
    HandleGetAllTickerDetails()
  }, [])

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            {buttonOptions?.length > 0 && (
              <TableHead scope="col" className="w-[6%] text-left text-[#0D215C] font-semibold">Actions</TableHead>
            )}
            <TableHead scope="col" className="text-[#0D215C] font-semibold" >Sr No.</TableHead>
            {columns?.map((column, index) => (
              <TableHead key={index} scope="col" className="text-[#0D215C] font-semibold" >{column.header}</TableHead>
            ))}
            {
              tableFor === "Ticker" &&
              (
                <TableHead scope="col" className="text-[#0D215C] font-semibold" >Status</TableHead>
              )
            }
          </TableRow>
        </TableHeader>
        <TableBody>
          {
            data && data?.length > 0 ?
              data?.map((item, rowIndex) =>
              (
                <TableRow className="cursor-default" key={rowIndex} onClick={() => onRowClick(rowIndex)}>
                  {buttonOptions?.length > 0 && (
                    <TableCell className="w-[6%] text-left">
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button
                            variant="ghost"
                            className="h-11 w-11 p-0"
                            aria-label={`Actions for ${item?.report_name || item?.name || `row ${rowIndex + 1}`}`}
                          >
                            <EllipsisVertical className="h-4 w-4" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          {buttonOptions.map((option, index) => (
                            <div key={index}>
                              <DropdownMenuItem>
                                <Button
                                  variant="none"
                                  className="flex items-center px-2 gap-4 h-6 text-sm"

                                  onClick={() => {
                                    if (tableFor === "Ticker") {
                                      if (option.name === "Delete") {

                                        // option.actionHandleDeleteTickerForScheme(item)
                                        handleDeleteConfirmation(item)
                                        return
                                      }
                                      if (option.name === "Edit") {
                                        return option.actionHandleEditTickerForScheme(item)
                                      }

                                    }
                                    if (tableFor === "Email-Template") {
                                      if (option.name === "Edit") {
                                        return option.actionHandleEditEmailTemplate(item)
                                      }
                                      if (option.name === "Delete") {
                                        handleDeleteConfirmation(item)
                                        // option.actionHandleDeleteEmailTemplate(item)
                                        return
                                      }
                                    }
                                  }}

                                >
                                  {option.icon}
                                  <span>{option.text}</span>
                                </Button>
                              </DropdownMenuItem>
                              {index < buttonOptions.length - 1 && (
                                <DropdownMenuSeparator />
                              )}
                            </div>
                          ))}
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  )}
                  <TableCell>{rowIndex + 1}</TableCell>
                  {columns?.map((header, colIndex) => (
                    <TableCell key={colIndex} className="flex-grow" aria-label={header.id === "report_name" ? `Report name ${item[header.id]}` : undefined} title={header.id === "report_name" ? item[header.id] : undefined}>
                      {header.id !== "created_at" ? item[header.id] : moment(item[header.id]).format("DD-MM-YYYY")}
                    </TableCell>

                  ))}
                  {tableFor === "Ticker" && <TableCell>
                    <Switch
                      defaultChecked={item.ticker_status} // Set the initial state based on data
                      onCheckedChange={(checked) => handleUpdateTickerStatus(item, checked)} // Call your function with the ticker_id and new state
                    />
                  </TableCell>}
                  {/* Conditionally render the action buttons if buttonOptions exist */}

                </TableRow>
              )
              )
              :
              <TableRow>
                <div className='h-10' ></div>
              </TableRow>



          }

        </TableBody>
      </Table>
      <div className="flex justify-end items-center m-4">

        <div>
          <span className="sr-only" role="status" aria-live="polite">
            Showing page {currentPage} of {totalPage}
          </span>
          <span>
            Page{" "}
            <strong>

              {currentPage}
              of{" "}
              {totalPage}
            </strong>{" "}
          </span>
          <label htmlFor={`page-select-${tableFor || 'default'}`} className="sr-only">Select page</label>
          {/* accessiblity fix for silktide issues */}
          <select
            id={`page-select-${tableFor || 'default'}`}
            value={currentPage + 1}
            onChange={(e) => handlePageChange(Number(e.target.value))}
            className="p-2 border border-[#0D215C] bg-white text-black rounded ml-2 mb-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] focus-visible:ring-offset-1"
          >
            {Array.from({ length: totalPage }, (_, index) => index + 1).map((page) => (
              <option key={page} value={page + 1}>
                Page {page}
              </option>
            ))}
          </select>
        </div>
      </div>
      <DialogBox
        isOpen={isOpenDeleteUserConfirmation}
        onClose={handleCloseDeleteUserConfirmation}
        title={`Delete ${tableFor === "Ticker" ? "Ticker" : tableFor === "Email-Template" ? "Email Template" : ""} Confirmation`}
        message={`Are you sure you want to delete ${tableFor === "Ticker" ? selectedItem?.ticker_name : tableFor === "Email-Template" ? selectedItem?.template_name : ""}, this ${tableFor === "Ticker" ? "Ticker" : tableFor === "Email-Template" ? "Email Template" : ""}? This action cannot be undone.`}
        onConfirm={handleDeleteConfirm}
      />
    </>
  )
}

export default DataTable2
